import React from "react";

import type { IAppMetrics } from "../../../hooks/reactQueryHooks/useBilling";
import type { PlaygroundModel } from "../../../hooks/reactQueryHooks/usePlayground";
import { ApplicationsTable } from "./ApplicationsTable";
import { Badges } from "./Badges";

export interface ApplicationsDetailsPageProps {
  data: IAppMetrics | undefined;
  cacheItemsCount: number | undefined;
  isLoading: boolean;
  models: PlaygroundModel[] | undefined;
}

const ApplicationsDetailsPage: React.FC<ApplicationsDetailsPageProps> = ({
  data,
  cacheItemsCount,
  isLoading,
  models,
}) => {
  return (
    <div className="card flex-shrink-1 flex-grow-1">
      <div className="app-container-inner-wrapper h-100">
        <Badges
          data={data}
          cacheItemsCount={cacheItemsCount}
          isLoading={isLoading}
        />
        <ApplicationsTable tokenMetrics={data} models={models} />
      </div>
    </div>
  );
};

export { ApplicationsDetailsPage };
